const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8000";

const getAuthHeaders = () => {
  const storedUser =
    localStorage.getItem("user") ||
    localStorage.getItem("localUser");

  const user = storedUser ? JSON.parse(storedUser) : null;

  if (!user?.id) {
    throw new Error("User session not found. Please login again.");
  }

  return {
    "Content-Type": "application/json",
    "X-User-Id": String(user.id),
  };
};

export const getSnapperMap = async () => {
  const response = await fetch(
    `${API_URL}/api/snapper-map`,
    {
      method: "GET",
      headers: getAuthHeaders(),
      credentials: "include",
    }
  );

  if (!response.ok) {
    const text = await response.text();

    throw new Error(
      `Snapper Map API failed: ${response.status} ${text}`
    );
  }

  return await response.json();
};